type OrdersErrorBannerProps = {
  ordersError: string
  retryLabel: string
  onRetryOrders: () => void
}

export const OrdersErrorBanner = ({ ordersError, retryLabel, onRetryOrders }: OrdersErrorBannerProps) => {
  if (!ordersError) return null

  return (
    <div className="rounded-2xl border border-(--color-status-error-border) bg-(--color-status-error-bg) px-4 py-3 text-sm text-(--color-status-error)">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>{ordersError}</span>
        <button
          type="button"
          onClick={onRetryOrders}
          className="ca-theme-transition rounded-full border border-(--color-status-error-border) px-3 py-1 text-xs font-semibold hover:bg-[color-mix(in_srgb,var(--color-status-error-bg)_85%,transparent)]"
        >
          {retryLabel}
        </button>
      </div>
    </div>
  )
}
